import { CommandContribution } from '@patsnap/tahiti-core/common/command';
import { LeaveSpaceContribution } from './leave-space-contribution';
import { SpaceActionContribution } from '@/services/space-action-contribution';
import { ApiBatchRejectSpaces } from '@/infrastructure/api-functions/api-batch-reject-spaces';
import { SpaceApiServiceImpl } from '@/infrastructure/api-functions/space-api-service';
import { LeaveSpacesRepository, LeaveSpacesService } from '@/domains/spaces/services/leave-space-service.interface';
import { LeaveSpacesRepositoryImpl } from '@/domains/spaces/repository/leave-spaces-repository';
import { LeaveSpacesServiceImpl } from '@/domains/spaces/services/leave-space-service';
export function leaveSpaceModule(bind) {
    bind(ApiBatchRejectSpaces).to(SpaceApiServiceImpl);
    bind(LeaveSpacesRepository).to(LeaveSpacesRepositoryImpl);
    bind(LeaveSpacesService).to(LeaveSpacesServiceImpl);
    bind(CommandContribution).to(LeaveSpaceContribution);
    bind(SpaceActionContribution).to(LeaveSpaceContribution);
}
